import script from "./UserIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./UserIcon.vue?vue&type=script&setup=true&lang=js"

import "./UserIcon.vue?vue&type=style&index=0&id=040d137c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-040d137c"]])

export default __exports__